export default __webpack_public_path__ + "static/media/livegists_logo.760e4042.png";